export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Yüzme antrenmanlarım bir uygulamada, bisiklet çalışmalarım bir tabloda, koşu planlarım ise notlarımdaydı. Altı aşamalı sistem sayesinde hazırlığımı tek bir yerde organize edebiliyorum. Artık her haftanın amacını daha net görüyorum.',
    name: 'Mehmet K.',
    location: 'İstanbul · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/8d2b43e2-f973-409d-b5fd-827d264aa3e7.jpg',
  },
  {
    quote:
      'Yüzme antrenmanlarını bazen erteliyordum çünkü yüzme, bisiklet ve koşuyu ayrı ayrı planlamak zor geliyordu. Hepsini bir arada görmek, haftalık hazırlığımı daha dengeli ve düzenli organize etmeme yardımcı oldu.',
    name: 'Zeynep A.',
    location: 'İzmir · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/1b6dd2ef-d110-41e6-84ee-92767be2e50c.jpg',
  },
  {
    quote:
      'Yoğun bir iş hayatım var ve antrenman için ayırdığım zamanı verimli kullanmak istiyorum. 40 haftalık takvim, hazırlık sürecimi ve sıradaki aşamayı görmemi kolaylaştırıyor. Artık ne kadar çalışmam gerektiğini sürekli tahmin etmeye çalışmıyorum.',
    name: 'Emre T.',
    location: 'Ankara · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/f0092094-8acb-4bef-8564-97158d274599.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Uzun bisiklet antrenmanlarında hep enerjim bitiyordu. Beslenme rehberi sayesinde ne yiyeceğimi ve ne zaman içeceğimi antrenmandan önce planlıyorum, yolun ortasında değil.',
    name: 'Elif S.',
    location: 'Antalya · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fba6fa09-bf14-4613-8b74-0c1b5161f11c.jpg',
  },
  {
    quote:
      'Gelişim takip çizelgesi beni dürüst tutuyor. Üç disiplindeki haftalık tutarlılığımı görmek, tek bir zor antrenmandan çok daha fazlasını anlatıyor.',
    name: 'Burak Y.',
    location: 'Bursa · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/1b835bb0-0f38-4230-b0c8-6b8881cc6886.jpg',
  },
  {
    quote:
      'Yarış haftası eskiden tam bir kaostu. Kontrol merkezi sayesinde çantalarım hazır, geçiş alanım planlı ve yarış sabahım netti. İlk kez başlangıç çizgisine sakin bir şekilde çıktım.',
    name: 'Selin D.',
    location: 'Alanya · Türkiye',
    flag: '🇹🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/11611e89-b85e-4c38-a323-a8539c480898.jpg',
  },
];
